import { Branding, useBCMSModal, useParams, useStateManager, useUIState, useWorkflowStep, BrandingStyle } from "bcms-react";
import { CustomAccordionClose, CustomAccordionContent } from "components/custom-ui/CustomAccordion";
import { FormRowView } from "components/shared";
import MobileTableAccordionView, { MobileTableAccordionToggle } from "components/shared/views/MobileTableAccordionView";
import { getDefaultSearch, getWorkflowSteps } from "components/workflows/DepositHistoryWorkflow";
import React, { useState } from "react";
import { ImageAsset, SVGAsset } from "res";
import { DepositHistoryNoResults, EndOfDepositsWidget, getDepositHistoryItemConfig } from "../DepositHistoryView";
import "./styles.css";


export default function MobileDepositHistoryView(props){
  const { data, ui } = useStateManager();

  const filtered = data.deposits;
  const isSearching = ui.isSearching;

  const depositRows = filtered.map((deposit, index) => {
    var account = deposit.account;
    return <MobileDepositHistoryAccordionView key={deposit.id} date={deposit.date.format("m/d/Y")} accountName={account.nickname} accountNumber={account.number}
     status={deposit.status} amount={deposit.amount.format()} transactionID={deposit.transactionID} source={deposit.source} depositID={deposit.id}/>
  }, []);


  return (
    <div className="mobile-deposit-history-view show-on-mobile">
      {depositRows.length > 0 &&
        <div className="status-header">
          <b className="status-header-text">Processed</b>
        </div> 
      }
     {depositRows}
     { !isSearching &&
    <EndOfDepositsWidget />
    }
     { depositRows.length < 1 &&  <DepositHistoryNoResults />}
    </div>
  );
}
/**
 * @function MobileDepositHistoryAccordionView
 * @param {STRING} transactionID - The transaction ID of each deposit.
 * @param {STRING} source - This is the source of where the transaction was made.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @returns {React.Component}
 * @exported false
 * @description This is the accordion details for each deposit history row. It shows the checks and more detailed info for each deposit.
 * @example
 * <DepositHistoryAccordionView transactionID="234" source="Mobile Phone" />
 */
 function MobileDepositHistoryAccordionView(props) {
  const uiStateConfig = getDepositHistoryItemConfig(props.depositID);
  const { config, key } = useUIState(uiStateConfig.key, uiStateConfig.value);
  const { onItemClick } = useStateManager();

  const toggleClick = evt => onItemClick(key, "accordionActive", !config.accordionActive);
  const checkToggle = evt => onItemClick(key, "showChecks", !config.showChecks);

  const date = props.date;
  const accountNumber = props.accountNumber;
  const accountName = props.accountName;
  const status = props.status;
  const amount = props.amount;
 
  const depositID = props.depositID;
  //const transactionID = props.transactionID ?? "[XXX]";
  // temporary solution since creating new deposits would increment the transaction id.
  const transactionID = "XXXX";
  const source = props.source ?? "[source]";
  const { open } = useBCMSModal();

  const onCheckImageClick = prop => val => {
    open("CheckImagePreviewModal", { view: prop });
  };

return <MobileTableAccordionView active={ config.accordionActive }>
<MobileTableAccordionToggle rightValue={<span data-point={`deposit_amount_${depositID}`}>{amount}</span>} onClick={ toggleClick } depositID={ depositID }>
    <div className="flex-container flex-vertical">
      <b className="date-label flex-height">{date}</b>
      <p className="account-info flex-height" data-point={`Mobile_deposit_account_${depositID}`}>{accountName} - {accountNumber}</p>
      <p className="status-text flex-height" data-point={`Mobile_deposit_status_${depositID}`}>{status}</p>
    </div>
</MobileTableAccordionToggle>
<CustomAccordionContent>
    <div className="flex-container flex-horizontal details-row">
      <p className="flex-width">DEPOSIT DETAILS</p>
      <CustomAccordionClose className="clickable" onClick={ toggleClick }>
        <SVGAsset id="CloseX" className="icon" data-point={`Mobile_Close_Deposit_${depositID}`}/>
      </CustomAccordionClose>
    </div>
    <FormRowView>
    <Branding id="view_check_images_abi22" value="true">
      <div className="flex-container flex-horizontal view-check">
        <BrandingStyle className="clickable link" style={{ "color": "links_abi22" }} element={
          <span  onClick={ checkToggle } data-point={`Mobile_Toggle_Deposit_Check_${depositID}`}>{config.showChecks ? "Hide" : "View"} Check</span>
        } />
      </div>
    </Branding> 
    </FormRowView>
    {config.showChecks &&
      <>
        <div className="flex-container flex-horizontal flex-wrap check-row">
          <ImageAsset id="CheckFront" className="flex-width clickable" data-point={`Mobile_Mobile_Front_Deposit_Check_${depositID}`} onClick={ onCheckImageClick("front") } />
          <ImageAsset id="CheckBack" className="flex-width clickable" data-point={`Mobile_Back_Deposit_Check_${depositID}`} onClick={ onCheckImageClick("back") } />
        </div>
      </>}
    <FormRowView text="Transaction ID">
      <p><b>{transactionID}</b></p>
    </FormRowView>
    <FormRowView text="Source">
      <p><b>{source}</b></p>
    </FormRowView>
</CustomAccordionContent>
</MobileTableAccordionView>
}